import { render, staticRenderFns } from "./AdminSchedulesModalRemoveDay.vue?vue&type=template&id=0c7ca956&scoped=true"
import script from "./AdminSchedulesModalRemoveDay.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesModalRemoveDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ca956",
  null
  
)

export default component.exports